export function categoryKeyToPath(key: string): string {
    return key.toLowerCase()
        .replace(/&/g, 'and')  // Replace "&" with "and"
        .replace(/\s+/g, '-')  // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, '');  // Remove any other special characters
}

/** Ignore trailing slash / casing when comparing SEO landing pathnames. */
export function normalizePathnameForCompare(pathname: string): string {
    return (pathname.replace(/\/$/, '') || '/').toLowerCase();
}